import {register} from '@shopify/theme-sections';

const selectors = {
  sliderContainer: '[data-slider-container]',
  slide: '[data-slide]',
  prevButton: '[data-prev-btn]',
  nextButton: '[data-next-btn]',
  videoSlide: '[data-video-slide]',
  videoWrapper: '[data-background-video]',
  video: '[data-video]',
  videoPlayBtn: '[data-video-play]',
  videoVolumeBtn: '[data-video-volume]',
};

const classes = {
  singleSlide: 'single-slide',
  selectedSlide: 'is-selected',
  videoPlaying: 'video-playing',
  isVisible: 'is-visible',
};

const sectionType = 'hero-slider';
const registeredSections = window.Shopify?.theme?.sections?.registered || {};
const isUnregistered = typeof registeredSections[sectionType] === 'undefined';

export default isUnregistered &&
  register(sectionType, {
    onLoad() {
      const container = this.container;

      const slider = container.querySelector(selectors.sliderContainer);
      if (!slider) return;

      const handleVideo = (index) => {
        const heroSlides = slider.querySelectorAll(selectors.slide);
        const videoWrapper = heroSlides[index]?.querySelector(selectors.videoWrapper);

        console.log(heroSlides, index, videoWrapper)
        if (!videoWrapper) return;

        const videos = videoWrapper.querySelectorAll('video');

        videos.forEach(async (video) => {

          const autoPlay = Boolean(video.attributes.autoplay);

          if(mediaType === 'mobile' && !autoPlay) return;

          if (!video.dataset.mediaType || video.dataset.mediaType === mediaType) {
            video.autoplay = true;
            await video.play();
            return;
          }

          video.pause();
        });

        videoWrapper.classList.add(classes.videoPlaying);
      };

      this.flickity = new Flickity(slider, {
        prevNextButtons: false,
        autoPlay: false,
        pageDots: false,
        adaptiveHeight: true,
        watchCSS: true,
        wrapAround: false,
        on: {
          ready() {
            slider.classList.add(classes.isVisible);
            handleVideo(0);
          },
          change(index) {
            handleVideo(index);

            // Reset current video play button style
            this.selectedElement.querySelector(selectors.videoPlayBtn)?.classList.add('paused');

            // Pause videos from other slides
            const videoSlides = slider.querySelectorAll(selectors.videoSlide);
            videoSlides.forEach((videoSlide) => {
              if (videoSlide === this.selectedElement) return;
              const videos = videoSlide.querySelectorAll('video');
              videos.forEach((video) => video.pause());
            });
          },
        },
      });

      const desktopQuery = window.matchMedia('(min-width: 768px)');
      let mediaType = desktopQuery.matches ? 'desktop' : 'mobile';

      desktopQuery.addEventListener('change', () => {
        mediaType = desktopQuery.matches ? 'desktop' : 'mobile';

        if (slider.classList.contains(classes.singleSlide)) {
          handleVideo(0);
          return;
        }

        if (this.flickity) {
          handleVideo(this.flickity.selectedIndex);
        }
      });

      this.initVideos();
      this.customControls();

      if (slider.classList.contains(classes.singleSlide)) {
        const slide = container.querySelector(selectors.slide);
        slide?.classList.add(classes.selectedSlide);
        handleVideo(0);
        return;
      }
    },

    onBlockSelect(event) {
      // Only run in the admin theme customizer
      if (!Shopify.designMode) {
        return;
      }

      // Scroll to selected slide
      const index = Array.from(event.target.parentElement.children).indexOf(event.target);
      if (this.flickity) {
        this.flickity.select(index);
      }
    },

    onDeselect() {
      // Only run in the admin theme customizer
      if (!Shopify.designMode) {
        return;
      }
    },

    // Initially unmute all videos but set volume to 0
    initVideos() {
      this.desktopVideos = document.querySelectorAll(`${selectors.videoWrapper} .component-video__video-desktop`);
      this.mobileVideos = document.querySelectorAll(`${selectors.videoWrapper} .component-video__video-mobile`);

      if (this.desktopVideos.length) {
        Array.from(this.desktopVideos).forEach((desktopVideo) => {
          desktopVideo.muted = false;
          desktopVideo.volume = 0;
        });
      }

      if (this.mobileVideos.length) {
        Array.from(this.mobileVideos).forEach((mobileVideo) => {
          mobileVideo.muted = true;
        });
      }
    },

    // Custom video controls for play/pause and mute/unmute
    customControls() {
      const playControls = this.container.querySelectorAll(selectors.videoPlayBtn);
      const volumeControls = this.container.querySelectorAll(selectors.videoVolumeBtn);

      Array.from(playControls).forEach((playControl) => {
        playControl.addEventListener('click', (event) => {
          const $this = event.currentTarget;
          const currentMediaType = $this.dataset.mediaType;
          const currentVideoId = $this.dataset.videoId;
          const currentVideo = document.querySelector(
            `${selectors.videoWrapper} .component-video__video-${currentMediaType}[data-video-id='${currentVideoId}']`
          );
          if ($this.classList.contains('paused')) {
            currentVideo.pause();
          } else {
            currentVideo.play();
          }
          $this.classList.toggle('paused');
        });
      });

      Array.from(volumeControls).forEach((volumeControl) => {
        volumeControl.addEventListener('click', (event) => {

          const $this = event.currentTarget;
          const currentMediaType = $this.dataset.mediaType;
          const currentVideoId = $this.dataset.videoId;
          const currentVideo = document.querySelector(
            `${selectors.videoWrapper} .component-video__video-${currentMediaType}[data-video-id='${currentVideoId}']`
          );
          if ($this.classList.contains('muted')) {
            currentVideo.muted = false;
            currentVideo.volume = 1;
          } else {
            currentVideo.muted = true;
            currentVideo.volume = 0;
          }
          $this.classList.toggle('muted');
        });
      });
    },
  });
